import React from 'react';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import { defaultEvent } from '../helper';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const SubscribersActions = ({
  category,
  code,
  event,
  readStatus,
}) => {
  const eventCode = event || defaultEvent(category);
  const { allowRefresh } = Selectors.useSubscribersActions({ category });
  const refresh = Events.useRefreshSubscribers(category, { code });

  return (
    <>
      {allowRefresh && (
        <RefreshActionMenu onClick={() => refresh({ event: eventCode, page: 1 })} readStatus={readStatus} />
      )}
    </>
  );
};

export default SubscribersActions;
